<div class="time-span">
    <ion-segment value="{{ currentScale }}" (ionChange)="changeScale($event)">
        <ion-segment-button
            data-test-id="button-history-daily"
            [value]="scale.DAILY"
            [disabled]="!canUseDayScale && currentScale !== scale.DAILY"
            mode="ios"
        >
            <ion-label class="body-bold">{{ 'PAGES.HISTORY.TIMESPAN.D' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button
            data-test-id="button-history-weekly"
            [value]="scale.WEEKLY"
            [disabled]="!canUseWeekAndMonthScales && currentScale !== scale.WEEKLY"
            mode="ios"
        >
            <ion-label class="body-bold">{{ 'PAGES.HISTORY.TIMESPAN.W' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button
            data-test-id="button-history-monthly"
            [value]="scale.MONTHLY"
            [disabled]="!canUseWeekAndMonthScales && currentScale !== scale.MONTHLY"
            mode="ios"
        >
            <ion-label class="body-bold">{{ 'PAGES.HISTORY.TIMESPAN.M' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button data-test-id="button-history-yearly" [value]="scale.YEARLY" mode="ios">
            <ion-label class="body-bold">{{ 'PAGES.HISTORY.TIMESPAN.Y' | translate }}</ion-label>
        </ion-segment-button>
        <!-- <ion-segment-button data-test-id="button-history-infinity" [value]="scale.INFINITY" mode="ios">
            <ion-label class="body-bold infinity">∞</ion-label>
        </ion-segment-button> -->
    </ion-segment>

    <div class="dates-value">
        <button
            data-test-id="button-history-previous"
            class="nav-dates-button"
            (click)="previous()"
            [disabled]="!canGoPrevious"
        >
            <ion-icon class="chevron back" name="chevron-back-sharp"></ion-icon>
        </button>
        <ion-label data-test-id="label-history-date" *ngIf="dateInterval" class="body-bold">{{
            dateInterval.displayedDate
        }}</ion-label>
        <button data-test-id="button-history-next" class="nav-dates-button" (click)="next()" [disabled]="!canGoNext">
            <ion-icon class="chevron forward" name="chevron-forward-sharp"></ion-icon>
        </button>
    </div>
</div>
